<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="toc">
<h1 class="fmtitle" epub:type="title"><span epub:type="pagebreak" id="page_vii" title="vii">Contents</span></h1>
<p class="toc"><a href="#/xhtml/08_Preface"><i>Preface</i></a></p>
<p class="toc"><a href="#/xhtml/09_Acknowledgement"><i>Acknowledgments</i></a></p>
<p class="toc"><a href="#/xhtml/10_Introduction"><i>Introduction</i></a></p>
<p class="toc1"><a href="#/xhtml/11_Part01"><span class="bor">PART ONE</span></a></p>
<p class="toc2"><a href="#/xhtml/11_Part01">The Institutional Infrastructure of Black Nursing</a></p>
<p class="toca"><a href="#/xhtml/12_Chapter01">1.  Origins of the Black Hospital and Nurse Training School Movement: An Overview</a></p>
<p class="toca"><span href="#/xhtml/13_Chapter02" title="Link target outside of Sample">2.  Northern Black Hospitals and Nurse Training Schools</span></p>
<p class="toca"><span href="#/xhtml/14_Chapter03" title="Link target outside of Sample">3.  Training Nurses in Southern Black Hospitals</span></p>
<p class="toca"><span href="#/xhtml/15_Chapter04" title="Link target outside of Sample">4.  Black Collegiate Nursing Education: A Case Study</span></p>
<p class="toc1"><span href="#/xhtml/16_Part02" title="Link target outside of Sample"><span class="bor">PART TWO</span></span></p>
<p class="toc2"><span href="#/xhtml/16_Part02" title="Link target outside of Sample">More Than Angels of Mercy</span></p>
<p class="toca"><span href="#/xhtml/17_Chapter05" title="Link target outside of Sample">5.  Racism, Status, and the Professionalization of Black Nursing</span></p>
<p class="toca"><span href="#/xhtml/18_Chapter06" title="Link target outside of Sample">6.  The Politics of Agency and the Revitalization of the NACGN</span></p>
<p class="toca"><span href="#/xhtml/19_Chapter07" title="Link target outside of Sample">7.  Black Women in White</span></p>
<p class="toca"><span href="#/xhtml/20_Chapter08" title="Link target outside of Sample">8.  “We Shall Not Be Left Out”: World War II and the Integration of Nursing</span></p>
<p class="toc"><span href="#/xhtml/21_Conclusion" title="Link target outside of Sample">Conclusion</span></p>
<p class="toct"><span href="#/xhtml/22_Appendix01" title="Link target outside of Sample"><i>Appendix</i></span></p>
<p class="toc"><span href="#/xhtml/23_Notes" title="Link target outside of Sample"><i>Notes</i></span></p>
<p class="toc"><span href="#/xhtml/24_Bibliography" title="Link target outside of Sample"><i>Bibliography</i></span></p>
<p class="toc"><span href="#/xhtml/25_Index01" title="Link target outside of Sample"><i>Index</i></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Contents.vue?245944b4